var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-left-1"},[_c('BorderBoxView1',{attrs:{"title":"保安当班人员"}},[_c('dv-scroll-board',{attrs:{"config":_vm.configValue}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }